<template>
    <div>
        <b-card :header="uLang('app.edit')" header-tag="h4" class="bg-default-card">
            <log-form
                entityType="organisations"
                :entityId="organisationId"
                :override-endpoint="overrideEndpoint"
                :id="logId"
            />
        </b-card>
    </div>
</template>

<script>
    import LogForm from '~/components/forms/logs/form'

    export default {
        name: 'edit',
        props: {
            organisationId: {
                required: true,
            },
            logId: {
                required: true
            }
        },
        components: {
            'log-form': LogForm,
        },
        computed: {
            overrideEndpoint() {
                return route('logs.index');
            }
        },
        created() {

        }
    }
</script>

<style lang="css" scoped>
</style>
